import React from 'react';
import '../index.css';
import img1 from '../assets/code.png'

function Navbar () {
  return (
    <div className='navbar h-20 flex flex-row justify-between  gap-0 sm:gap-28 items-center top-0 right-0 w-full bg-[#0F1720] fixed z-50'>
      <div className='nav-img flex flex-row justify-between items-center gap-14 pl-16'>
        <img src={img1} alt='' className='w-8' />
        <div className='hidden md:flex flex-row'>
          <ul className='flex flex-row gap-3 text-white'>
            <li>
              <a href='home'>Home</a>
            </li>
            <li>
              <a href='about'>About</a>
            </li>
            <li>
              <a href='services'>Services</a>
            </li>
            <li>
              <a href='pricing'>Pricing</a>
            </li>
          </ul>
        </div>
      </div>
      <div className='pr-24'>
        <button className='mybtn'>Contact Us</button>
      </div>
    </div>
  )
}

export default Navbar
